// extracted by mini-css-extract-plugin
module.exports = {"paperMenu":"VIP_ShowroomMenu__paperMenu","list":"VIP_ShowroomMenu__list"};